<template>
  <div>
    <div
      class="signup"
      :class="`signup--${currentStep}`"
    >
      <div class="signup__body">
        <div class="signup__body__inner">
          <transition
            :name="slideTransition"
            mode="out-in"
          >
            <router-view class="signup__current-step" />
          </transition>
          <div class="signup__body__sidebar">
            <Cart
              v-if="!['pass', 'orderComplete'].includes(currentStep)"
              class="signup__cart"
            />
            <Receipt v-if="currentStep == 'orderComplete'" />
            <div
              v-if="currentStepIndex > 0 && currentStep !== 'orderComplete'"
              class="signup__step-count"
            >
              Step <span>{{ currentStepIndex }}</span> of <span>{{ totalSteps }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cart from '../components/Cart.vue';
import Receipt from '../components/Receipt.vue';

export default {
  components: {
    Cart, Receipt,
  },
  data() {
    return {
      slideTransition: 'next',
      isEdited: false,
    };
  },
  computed: {
    registration() {
      return this.$store.state.registration;
    },
    user() {
      return this.$store.state.user;
    },
    order() {
      return this.$store.state.order;
    },
    passType() {
      return this.$store.getters.passType;
    },
    currentStepIndex() {
      return this.steps.indexOf(this.$route.name);
    },
    currentStep() {
      return this.steps[this.currentStepIndex];
    },
    previousStep() {
      if (this.currentStepIndex === 0) {
        return null;
      }
      return this.steps[this.currentStepIndex - 1];
    },
    steps() {
      return this.$store.getters.steps;
    },
    totalSteps() {
      return this.steps.length - 2;
    },
    backLabel() {
      if (this.$route.params.pass && this.previousStep === 'pass') {
        return 'Change pass type';
      }
      return 'Back';
    },
  },
  watch: {
    user: {
      handler() {
        this.isEdited = true;
      },
      deep: true,
    },
    order() {
      if (this.order.complete) {
        this.isEdited = false;
      }
    },
    isEdited() {
      window.onbeforeunload = this.isEdited ? function onbeforeunload() { return true; } : null;
    },
  },
  created() {
    this.$store.dispatch('testPayButtonSupport');
  },
  beforeRouteUpdate(to, from, next) {
    const fromIndex = this.steps.indexOf(from.name);
    const toIndex = this.steps.indexOf(to.name);

    this.slideTransition = toIndex > fromIndex ? 'next' : 'prev';
    next();
  },
  beforeRouteLeave(to, from, next) {
    // eslint-disable-next-line no-alert
    if (!this.isEdited || this.$store.state.order.complete || window.confirm('Are you sure you want to leave? Any unsaved changes will be lost')) {
      window.onbeforeunload = null;
      next();
    }
  },
};
</script>
